export const ADMIN_GROUP = "Admin";
export const BLOGGER_GROUP = "Blogger";
export const ENGINEER_GROUP = "Engineer";
export type UserGroup =
  | typeof ADMIN_GROUP
  | typeof ENGINEER_GROUP
  | typeof BLOGGER_GROUP;
